export const ROOT = {
  PREFETCH_START: 'PREFETCH_START',
  PREFETCH_FINISHED: 'PREFETCH_FINISHED',
};
